export default __webpack_public_path__ + "static/media/timage1.d0272eea.jpeg";